import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/SC80.png'
import _imports_1 from '../assets/images/SC50.png'
import _imports_2 from '../assets/control/battery.png'
import _imports_3 from '../assets/control/charging.png'
import _imports_4 from '../assets/control/water.png'
import _imports_5 from '../assets/control/sewage.png'


const _withScopeId = n => (_pushScopeId("data-v-ec332b68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BasicInfo" }
const _hoisted_2 = {
  key: 0,
  style: {"width":"50px"},
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  style: {"width":"40px"},
  src: _imports_1,
  alt: ""
}
const _hoisted_4 = { class: "vehicletype ellipsis" }
const _hoisted_5 = { style: {"user-select":"all","font-weight":"bold"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "test" }
const _hoisted_8 = {
  key: 0,
  src: _imports_2
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  src: _imports_3
}
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { class: "test" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_14 = { class: "test" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_16 = { class: "basicInfo-mapinfo" }
const _hoisted_17 = { style: {"font-weight":"bold"} }
const _hoisted_18 = { class: "mapname" }
const _hoisted_19 = { class: "location" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { class: "basicInfo-main" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 2 }, {
                  default: _withCtx(() => [
                    (_ctx.basicInfo?.vehicle_type === 'SC80')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                      : _createCommentVNode("", true),
                    (_ctx.basicInfo?.vehicle_type === 'SC50')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 2 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.basicInfo?.vehicle_model), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.basicInfo?.vin), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.getCarStatusType(_ctx.basicInfo?.vehicle_status, _ctx.t)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 2 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.basicInfo?.speed) + "m/s", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 2 }, {
                  default: _withCtx(() => [
                    (_ctx.basicInfo?.is_falut)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.t("malfunction")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 2 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.basicInfo?.charging_state != _ctx.charging)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                        : _createCommentVNode("", true),
                      (_ctx.basicInfo?.charging_state != _ctx.charging)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.t("electricitylevel")) + ":" + _toDisplayString(_ctx.basicInfo?.electricity) + "%", 1))
                        : _createCommentVNode("", true),
                      (_ctx.basicInfo?.charging_state == _ctx.charging)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : _createCommentVNode("", true),
                      (_ctx.basicInfo?.charging_state == _ctx.charging)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.t("charging")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 2 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createTextVNode(_toDisplayString(_ctx.t("cleanwatertank")) + ":" + _toDisplayString(_ctx.basicInfo?.clean_water_rate) + "% ", 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 2 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createTextVNode(_toDisplayString(_ctx.t("bilgetank")) + ":" + _toDisplayString(_ctx.basicInfo?.sewage_rate) + "% ", 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.mapname), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.floorName), 1)
              ]),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.mLocationFail
                ? _ctx.t("positioningfailed")
                : _ctx.getCarLocationStatus(_ctx.basicInfo?.location_status, _ctx.t)), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}